var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "property_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M2 21L24 3l22 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 24v21h34V24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 22,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 30a9 9 0 00-9 9h18a9 9 0 00-9-9z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+c3RheSBob21lPC90aXRsZT48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMjcyNzI2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIj48cG9seWxpbmUgcG9pbnRzPSIyIDIxIDI0IDMgNDYgMjEiIGRhdGEtY2FwPSJidXR0Ij48L3BvbHlsaW5lPjxwb2x5bGluZSBwb2ludHM9IjcgMjQgNyA0NSA0MSA0NSA0MSAyNCI+PC9wb2x5bGluZT48Y2lyY2xlIGN4PSIyNCIgY3k9IjIyIiByPSI0IiBzdHJva2U9IiMyNzI3MjYiPjwvY2lyY2xlPjxwYXRoIGQ9Ik0yNCwzMGE5LDksMCwwLDAtOSw5SDMzQTksOSwwLDAsMCwyNCwzMFoiIHN0cm9rZT0iIzI3MjcyNiI+PC9wYXRoPjwvZz48L3N2Zz4=";
export { SvgProperty as ReactComponent };